import { fetchUnsettledSecuritiesPosition1 } from '@/api/business/unsettledSecurities'
import { useQuery } from '@tanstack/react-query'

export const UnsettledSecuritiesPosition1Keys = {
    all: ['unsettledsecuritiesposition1'] as const,
    lists: () => [...UnsettledSecuritiesPosition1Keys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...UnsettledSecuritiesPosition1Keys.lists(), page, perPage, filters] as const,
    details: () => [...UnsettledSecuritiesPosition1Keys.all, 'detail'] as const,
    detail: (params: string) => [...UnsettledSecuritiesPosition1Keys.details(), params] as const,
}

export const useUnsettledSecuritiesPosition1Query = () => {
    return useQuery({
        queryFn: fetchUnsettledSecuritiesPosition1,
        queryKey: UnsettledSecuritiesPosition1Keys.lists(),
    })
}
